import React, { useEffect } from 'react';
import Icon from './AppIcon';
import Button from './ui/Button';
import { emailService } from '../services/emailService';
import { useAuth } from '../contexts/AuthContext';

const CrisisResourceBanner = () => {
  const { user } = useAuth();

  const handleEmergencyCall = () => {
    window.location.href = 'tel:131114';
  };

  const handleCrisisChat = () => {
    window.open('https://www.lifeline.org.au/get-help/services/chat', '_blank', 'noopener,noreferrer');
  };

  const handleSendCrisisEmail = async () => {
    // Only send email if user is authenticated
    if (!user) return;

    try {
      const result = await emailService?.sendCrisisResources();
      // Silently handle if Edge Function not deployed or has errors
      if (result?.notDeployed) {
        console.info('Crisis resources email feature requires Edge Function deployment');
      }
    } catch (error) {
      // Silently fail - don't disrupt user experience
      console.info('Crisis resources email not available:', error?.message);
    }
  };

  // Send crisis resources email when component mounts (only if authenticated)
  React.useEffect(() => {
    handleSendCrisisEmail();
  }, []);

  return (
    <div className="crisis-banner">
      <div className="crisis-banner-content">
        <div className="crisis-banner-text">
          <Icon name="AlertCircle" size={20} />
          <span>Crisis Support Available 24/7</span>
        </div>
        <div className="crisis-banner-actions">
          <Button
            variant="ghost"
            size="sm"
            iconName="Phone"
            iconPosition="left"
            onClick={handleEmergencyCall}
            className="text-error-foreground hover:bg-error-foreground/10"
          >
            Call 13 11 14
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="MessageCircle"
            iconPosition="left"
            onClick={handleCrisisChat}
            className="text-error-foreground hover:bg-error-foreground/10"
          >
            Chat Now
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CrisisResourceBanner;